import { Form } from 'react-bootstrap';
import { useMasterData } from '../Context/masterDataContext';

// Reusable station selector — shows only the caller's tagged stations (admins get all).
export default function StationPicker({ value, onChange, disabled }) {
  const { useMyStations } = useMasterData();
  const { data: stations, isLoading } = useMyStations();

  return (
    <Form.Select
      value={value || ''}
      disabled={disabled || isLoading}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <option value="">{isLoading ? 'Loading stations…' : 'Select station…'}</option>
      {(stations || []).map((s) => (
        <option key={s.stationGuid} value={s.stationGuid}>
          {s.stationName}{s.officeCode ? ` (${s.officeCode})` : ''}
        </option>
      ))}
    </Form.Select>
  );
}
